module.exports = __webpack_public_path__ + "static/img/nose_08.562d5d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/noses/thumbnail/nose_08.png
// module id = nH85
// module chunks = 0